/*********************
Pass 2 :  Ideal Intervention
*********************/
import Pass from '../Pass';
import getIntervention from '../../../interventions/interventionFactory';

export default class Pass2 extends Pass {
  constructor(PASS_CONFIGS) {
    super();
    this.label = "PASS_2";

    const {
      selectionRulesByIntervention, // Possible interventions and their corresponding pass-specific rules
    } = PASS_CONFIGS.pass2;

    // Instantiate config-specified interventions, with any config-specified additional rules
    Object.entries(selectionRulesByIntervention).forEach(([interventionType,ruleData]) => {
      if(!PASS_CONFIGS.disabledInterventionTypes.includes(interventionType)) {
        super.addIntervention(getIntervention(interventionType, ruleData));// TODO, incorporate intervention "modes"
      }
    });
  }

  run(state) {
    super.resetForNextRun(); // Reset class vars (rationaleLog, runStillValid, and selectedIntervention)

    // Identify valid interventions, based on state and pass configs
    super.qualifyInterventions(state);

    // Select the "best" valid intervention, based on Ready Score
    super.selectBestValidInterventionByReadyScoreDiscountingSpellout(state);

    // Return the selected intervention
    return super.getRunResults();
  }
}